package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2026_03_21_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We return to our heroes at the Stealthy Elf Inn in Kostigan on the island of Ostvel.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Annette uses her magical spyglass to check in on Ludwig Voss. Sadly, he is both alive and no longer an adorable quokka. He appears to be imprisoned in an 8x8-foot windowless stone cell, possibly underground. The cell is furnished with a bucket for poop, and maybe he can make friends with the rats — share what they have in common.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("During Annette and Korvis’s night watch, Korvis notices something.")
    }
    com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.QUOTE, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text(" Oh no, I must go, I have been summoned. Sore-ee. This can’t wait.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("He vanishes.")
    }
}
